<template>
    <div class="dialog-search-info-customer">
        <div style="display:flex; gap:12px; align-items:center; margin-bottom:12px;">
            <el-input
                v-model="form.keyword"
                placeholder="Nhập mã nhân sự, tên sale"
                prefix-icon="el-icon-search"
                clearable
                @input="onSearchInput"
                style="width: 280px;"
            />

            <el-input
                v-model="form.phone"
                type="number"
                placeholder="Nhập số điện thoại khách hàng"
                prefix-icon="el-icon-phone"
                clearable
                @input="onSearchInput"
                style="width: 280px;"
            />

            <el-select
                v-if="[6].includes(keyAccount)"
                v-model="form.area_id"
                placeholder="Lọc theo khu vực"
                clearable
                filterable
                @change="onAreaChange"
                style="width: 220px;"
            >
                <el-option
                    v-for="item in areas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
            </el-select>

            <el-select
                v-if="[4,5,6].includes(keyAccount)"
                v-model="form.branch_id"
                placeholder="Lọc theo chi nhánh"
                clearable
                filterable
                @change="onBranchChange"
                style="width: 220px;"
            >
                <el-option
                    v-for="item in branches"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
            </el-select>
        </div>

        <!-- Bảng dữ liệu -->
        <el-table :data="tableData" style="width: 100%" :loading="loading">
            <el-table-column prop="sale_id" label="Mã nhân sự" width="120" />
            <el-table-column prop="sale_name" label="Tên Nhân sự" />
            <el-table-column prop="branch_name" label="Tên chi nhánh" />
            <el-table-column prop="customer_name" label="Tên Khách hàng" />
            <el-table-column prop="customer_phone" label="Sđt Khách hàng" />
            <el-table-column prop="area_name" label="Khu vực" />
            <el-table-column label="Hành động" width="120">
                <template v-slot="scope">
                    <el-tooltip content="Xem thông tin khách hàng" placement="top">
                        <router-link
                            :to="{ name: 'customer-view', params: { id: scope.row.user_id }, query: { customer_id: scope.row.id } }"
                            class="btn btn-info btn-sm btn-icon waves-effect waves-themed"
                        >
                            <i class="fa fa-eye"></i>
                        </router-link>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <!-- Phân trang -->
        <div class="mt-3" style="display:flex; justify-content:center;">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="paging.current_page"
                :page-size="paging.per_page"
                layout="prev, pager, next"
                :total="paging.total"
            />
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { BRANCH_LIST } from '@/core/services/store/service.module'
import { GET_REGIONS_BY_USER, GET_CUSTOMER_BY_USER } from '@/core/services/store/customer/customer.module'
import {mapGetters} from "vuex";

export default {
    name: 'DialogSearchInfoCustomer',
    data() {
        return {
            form: {
                keyword: '',
                phone: '',
                branch_id: null,
                area_id: null,
            },
            tableData: [],
            areas: [],
            branches: [],
            loading: false,
            paging: {
                current_page: 1,
                per_page: 25,
                total: 0,
            },
            debouncedSearch: null,
        }
    },
    created() {
        this.debouncedSearch = debounce(this.applyFilters, 400)
    },
    mounted() {
        this.getRegions()
        this.getBranch()
    },
    methods: {
        // debounce ô search
        onSearchInput() {
            this.paging.current_page = 1
            this.debouncedSearch()
        },

        onAreaChange() {
            this.form.branch_id = null
            this.paging.current_page = 1
            this.getBranch().then(() => this.applyFilters())
        },

        onBranchChange() {
            this.paging.current_page = 1
            this.applyFilters()
        },

        handleCurrentChange(page) {
            this.paging.current_page = page
            this.applyFilters()
        },

        applyFilters() {
            if(!this.form.keyword && !this.form.phone) {
                this.tableData = []
                return
            }

            this.loading = true
            const payload = {
                keyword: this.form.keyword,
                phone: this.form.phone,
                branch_id: this.form.branch_id,
                area_id: this.form.area_id,
                page: this.paging.current_page,
                per_page: this.paging.per_page,
            }

            this.$store
                .dispatch(GET_CUSTOMER_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true})
                        return
                    }
                    const rows =
                        response?.data?.data ?? // Laravel resource có bọc data
                        response?.data ?? // API tuỳ biến trả mảng data
                        []

                    const meta =
                        response?.pagination ??
                        response?.data?.meta ?? // Laravel resource meta
                        {}

                    this.tableData = rows
                    this.paging.total = Number(meta.total ?? 0)
                    this.paging.per_page = Number(meta.per_page ?? this.paging.per_page)
                    this.paging.current_page = Number(meta.current_page ?? this.paging.current_page)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        // Lấy danh sách chi nhánh theo khu vực (filter phụ thuộc)
        getBranch() {
            const payload = {area_id: this.form.area_id}
            return this.$store.dispatch(BRANCH_LIST, payload).then((response) => {
                if (response.status === 422) {
                    this.$message({type: 'warning', message: `${response.message}`, showClose: true})
                } else {
                    this.branches = response.data || []
                }
            })
        },

        // Lấy danh sách khu vực theo user
        getRegions() {
            return this.$store.dispatch(GET_REGIONS_BY_USER, {}).then((response) => {
                if (response.status === 422) {
                    this.$message({type: 'warning', message: `${response.message}`, showClose: true})
                } else {
                    this.areas = response.data || []
                }
            })
        },
    },
    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
    }
}
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>

